// import  { useState, useEffect, useRef } from "react";
// import { getCookie } from "../../utils/cookieUtil";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch, faTrashAlt, faShareSquare, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
// import { useNavigate } from 'react-router-dom';
// import AdminUsers from "../../components/AdminManagment/AdminUsers";
// import FacultyUsers from "../../components/AdminManagment/Faculty";
// import AddAdminUser from "./AddAdminUser";
// import AddFaculty from "./AddFaculty";
// import { confirmDeleteAdminUser, confirmDeleteFacultyUser } from "../../services/authService";


// const LoadingSpinner = () => (
//   <div className="fixed inset-0 flex h-full items-center justify-center bg-gray-800 bg-opacity-50 z-50">
//     <div className="w-16 h-16 border-t-4  border-[#900028] border-solid rounded-full animate-spin"></div>
//   </div>
// );



// export default function AdminManagement() {
//   const [activeTab, setActiveTab] = useState("adminuser");
//   const [counter, setCounter] = useState(0);
//   const [permission, setPermission] = useState('');
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedIds, setSelectedIds] = useState([]);
//   const [showConfirmDelete, setShowConfirmDelete] = useState(false);
//   const [selectedGroup, setSelectedGroup] = useState("");
//   const [reloadCounter, setReloadCounter] = useState(0);
//   const [loading, setLoading] = useState(false);



//   const dropdownRef = useRef();
//   const exportRef = useRef();



//   const navigate = useNavigate();



//   useEffect(() => {
//     const roles = getCookie('roleId');
//     if (roles) {
//       setPermission(`${roles} `);
//     }
//   }, []);

//   const handleSearch = () => {

//   };


//   const handleReload = () => {
//     setReloadCounter(prev => prev + 1);

//   };

//   const handleGlobalShare = () => {
//     if (exportRef.current) {
//       exportRef.current(); // Trigger the export function inside AdminUsersTable
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       setLoading(true);

//       for (const userId of selectedIds.admin ?? []) {
//         await confirmDeleteAdminUser(userId);
//       }

//       for (const userId of selectedIds.faculty ?? []) {
//         await confirmDeleteFacultyUser(userId);
//       }

//       setSelectedIds({ admin: [], faculty: [] });
//       // setCounter(prev => prev + 1);
//       setReloadCounter(prev => prev + 1);
//       setShowConfirmDelete(false);
//     } catch (error) {
//       console.error("Error deleting users:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClose = () => {
//     setShowModal(false);
//   };

//   return (
//     <div className="p-4 space-y-4">
//       {/* Search and Buttons */}
//       <div className="flex items-center mb-6 space-x-2 justify-end">
//         <div className="flex items-center w-full max-w-xs border border-[#900028] rounded-md focus-within:border-[#900028]">
//           <input
//             type="text"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
//             className="flex-grow p-1 outline-none rounded-l-md border-none"
//             placeholder="Search..."
//           />
//           <button
//             onClick={handleSearch}
//             className="bg-[#900028] text-white px-4 py-1 rounded-r-md"
//           >
//             <FontAwesomeIcon icon={faSearch} />
//           </button>
//         </div>

//         {/* Action Buttons */}
//         <div className="flex space-x-2 items-center">
//           <button
//             onClick={() => setShowConfirmDelete(true)}
//             disabled={selectedIds.length === 0}
//             style={{
//               cursor: selectedIds.length === 0 ? "not-allowed" : "pointer",
//               background: "transparent",
//               border: "none",
//             }}
//           >
//             <FontAwesomeIcon
//               icon={faTrashAlt}
//               style={{ color: "#900028", fontSize: "25px" }}
//             />
//             </button>

//           <button onClick={handleGlobalShare} className="p-2">
//             <FontAwesomeIcon icon={faShareSquare} style={{ color: '#900028', fontSize: '25px' }} />
//           </button>






//           <button onClick={handleReload} className="p-2">
//             <FontAwesomeIcon icon={faRedoAlt} style={{ color: '#900028', fontSize: '25px' }} />

//           </button>
//         </div>
//       </div>

//       {/* Tabs and Invite Button */}
//       <div className="flex items-center space-x-2">

//         <div className="flex w-80 rounded-full overflow-hidden">
//           {["adminuser", "faculty"].map((tabKey, idx) => (
//             <button
//               key={tabKey}
//               className={`
//           w-1/2 px-4 py-2 text-sm font-semibold transition-colors duration-200
//         focus:outline-none border border-transparent
//         ${activeTab === tabKey
//                   ? "bg-[#900028] text-white"
//                   : "bg-gradient-to-b from-gray-100 to-gray-300 text-black hover:border-[#900028]"}
//         ${idx === 0 ? "rounded-l-full" : ""}
//         ${idx === 1 ? "rounded-r-full" : ""}
//       `}
//               onClick={() => {
//                 setActiveTab(tabKey);
//                 setCounter((prev) => prev + 1);
//                 setSearchQuery("");
//                 setSelectedGroup("");
//               }}
//             >
//               {tabKey === "adminuser" ? "Admin Users" : "Faculty"}
//             </button>
//           ))}
//         </div>





//         {/* Add Button */}
//         <button
//           className="w-40 px-4 py-2 text-sm font-semibold transition-colors duration-200 
//             bg-gradient-to-b from-gray-100 to-gray-300 text-black rounded-full 
//             border border-gray-900 hover:border-[#900028]"
//           onClick={() => {
//             setShowModal(true);
//           }}
//         >
//           {activeTab === "adminuser" ? "Add Admin" : "Add Faculty"}
//         </button>
//       </div>

//       {/* Tab Content Area */}
//       <div className="relative ">
//         {/* Modal container */}
//         {showModal && (
//           <div className="fixed bg-black bg-opacity-30 z-40 inset-0 flex justify-center">
//             <div className="p-6 w-[800px]">
//               {activeTab === "adminuser" ? (
//                 <AddAdminUser closeModal={handleClose} onSuccess={handleReload} />
//               ) : (
//                 <AddFaculty closeModal={handleClose} onSuccess={handleReload} />
//               )}
//             </div>
//           </div>
//         )}


//         {/* Main table content */}
//         <div>
//           {/* Tab Content */}
//           {activeTab === "adminuser" ? (
//             <AdminUsers
//               counter={reloadCounter}
//               searchMailQuery={searchQuery}
//               selectedIds={selectedIds}
//               setSelectedIds={setSelectedIds}
//               selectedGroup={selectedGroup}
//               onExportRef={exportRef}

//             />
//           ) : (
//             <FacultyUsers
//               counter={reloadCounter}
//               searchMailQuery={searchQuery}
//               selectedIds={selectedIds}
//               setSelectedIds={setSelectedIds}
//               selectedGroup={selectedGroup}
//               onExportRef={exportRef}


//             />
//           )}
//           {showConfirmDelete && (
//             <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
//               <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
//                 <h3 className="text-xl font-semibold mb-4">Confirm Delete</h3>
//                 <p className="mb-6">
//                   Are you sure you want to delete the selected users?
//                 </p>
//                 <div className="flex justify-end gap-4">
//                   <button
//                     onClick={() => setShowConfirmDelete(false)}
//                     className="px-4 py-2 rounded bg-gray-300 text-black hover:bg-gray-400"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleDelete}
//                     className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
//                   >
//                     Delete

//                   </button>

//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//         {loading && <LoadingSpinner />}
//       </div>
//     </div>
//   );
// }





import { useState, useEffect, useRef } from "react";
import { getCookie } from "../../utils/cookieUtil";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrashAlt, faShareSquare, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import AdminUsers from "../../components/AdminManagment/AdminUsers";
import FacultyUsers from "../../components/AdminManagment/Faculty";
import AddAdminUser from "./AddAdminUser";
import AddFaculty from "./AddFaculty";
import { confirmDeleteAdminUser, confirmDeleteFacultyUser } from "../../services/authService";

const LoadingSpinner = () => (
  <div className="fixed inset-0 flex h-full items-center justify-center bg-gray-800 bg-opacity-50 z-50">
    <div className="w-16 h-16 border-t-4 border-[#900028] border-solid rounded-full animate-spin"></div>
  </div>
);

export default function AdminManagement() {
  const [activeTab, setActiveTab] = useState("adminuser");
  const [counter, setCounter] = useState(0);
  const [permission, setPermission] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedIds, setSelectedIds] = useState({ admin: [], faculty: [] });
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [reloadCounter, setReloadCounter] = useState(0);
  const [loading, setLoading] = useState(false);

  const dropdownRef = useRef();
  const exportRef = useRef();

  const navigate = useNavigate();

  useEffect(() => {
    const roles = getCookie('roleId');
    if (roles) {
      setPermission(`${roles} `);
    }
  }, []);



  const handleReload = () => {
    setReloadCounter(prev => prev + 1);
  };

  const handleGlobalShare = () => {
    if (exportRef.current) exportRef.current();
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      for (const userId of selectedIds.admin ?? []) {
        await confirmDeleteAdminUser(userId);
      }
      for (const userId of selectedIds.faculty ?? []) {
        await confirmDeleteFacultyUser(userId);
      }
      setSelectedIds({ admin: [], faculty: [] });
      setReloadCounter(prev => prev + 1);
      setShowConfirmDelete(false);
    } catch (error) {
      console.error("Error deleting users:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => { setShowModal(false); };
  const isDeleteDisabled =
    (!selectedIds.admin || selectedIds.admin.length === 0) &&
    (!selectedIds.faculty || selectedIds.faculty.length === 0);


  return (
    <div className="p-4 space-y-4">
      {/* Search and Buttons */}
      <div className="flex flex-col sm:flex-row items-center mb-6 space-y-2 sm:space-y-0 sm:space-x-2 justify-end">
        <div className="flex items-center w-full max-w-xs border border-[#900028] rounded-md focus-within:border-[#900028]">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter'}
            className="flex-grow p-2 sm:p-1 outline-none rounded-l-md border-none text-sm sm:text-base"
            placeholder="Search by mail"
          />
          <button
            className="bg-[#900028] text-white px-3 sm:px-4 py-2 sm:py-1 rounded-r-md"
            aria-label="Search"
          >
            <FontAwesomeIcon icon={faSearch} className="text-base sm:text-lg" />
          </button>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3 items-center">
          <button
            onClick={() => setShowConfirmDelete(true)}
            disabled={isDeleteDisabled}
            style={{
              cursor: isDeleteDisabled ? "not-allowed" : "pointer",
              background: "transparent",
              border: "none",
            }}
            className="p-1 sm:p-2"
            aria-label="Delete Selected Users"
          >
            <FontAwesomeIcon
              icon={faTrashAlt}
              className={`text-xl sm:text-2xl md:text-3xl text-[#900028] ${isDeleteDisabled ? "opacity-50" : "opacity-100"}`}
            />
          </button>

          <button
            onClick={handleGlobalShare}
            className="p-1 sm:p-2"
            aria-label="Share selected users"
          >
            <FontAwesomeIcon
              icon={faShareSquare}
              className="text-xl sm:text-2xl text-[#900028]"
            />
          </button>

          <button
            onClick={handleReload}
            className="p-1 sm:p-2"
            aria-label="Reload data"
          >
            <FontAwesomeIcon
              icon={faRedoAlt}
              className="text-xl sm:text-2xl text-[#900028]"
            />
          </button>
        </div>
      </div>

      {/* Tabs and Invite Button */}
      <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
        <div className="flex w-80 rounded-full overflow-hidden">
          {["adminuser", "faculty"].map((tabKey, idx) => (
            <button

              key={tabKey}
              className={`
    
             

                  w-1/2 px-4 py-2 text-sm font-semibold transition-colors duration-200
        focus:outline-none border border-transparent

                ${activeTab === tabKey
                  ? "bg-[#900028] text-white"
                  : "bg-gradient-to-b from-gray-100 to-gray-300 text-black hover:border-[#900028]"
                }
                ${idx === 0 ? "rounded-l-full" : ""}
                ${idx === 1 ? "rounded-r-full" : ""}
              `}
              onClick={() => {
                setActiveTab(tabKey);
                setCounter(prev => prev + 1);
                setSearchQuery("");
                setSelectedGroup("");
              }}
            >
              {tabKey === "adminuser" ? "Admin Users" : "Faculty"}
            </button>
          ))}
        </div>

        {/* Add Button */}
        <button
          className="w-40 px-4 py-2 text-sm font-semibold transition-colors duration-200 
          bg-gradient-to-b from-gray-100 to-gray-300 text-black rounded-full 
             border border-gray-900 hover:border-[#900028]"
          onClick={() => setShowModal(true)}
        >
          {activeTab === "adminuser" ? "Add Admin" : "Add Faculty"}
        </button>
      </div>

      {/* Tab Content Area */}
      <div className="relative">
        {/* Modal container */}
        {showModal && (
          <div className="fixed bg-black bg-opacity-30 z-40 inset-0 flex justify-center items-center p-4">
            <div className="p-6 w-full max-w-[800px] ">
              {activeTab === "adminuser" ? (
                <AddAdminUser closeModal={handleClose} onSuccess={handleReload} />
              ) : (
                <AddFaculty closeModal={handleClose} onSuccess={handleReload} />
              )}
            </div>
          </div>
        )}

        {/* Main table content */}
        <div>
          {activeTab === "adminuser" ? (
            <AdminUsers
              counter={reloadCounter}
              searchMailQuery={searchQuery}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              selectedGroup={selectedGroup}
              onExportRef={exportRef}
            />
          ) : (
            <FacultyUsers
              counter={reloadCounter}
              searchMailQuery={searchQuery}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              selectedGroup={selectedGroup}
              onExportRef={exportRef}
            />
          )}

          {showConfirmDelete && (
            <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
                <h3 className="text-xl font-semibold mb-4">Confirm Delete</h3>
                <p className="mb-6">Are you sure you want to delete the selected users?</p>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={() => setShowConfirmDelete(false)}
                    className="px-4 py-2 rounded bg-gray-300 text-black hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
                  >
                    Delete
                  {loading && <LoadingSpinner />}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
     
      </div>
    </div>
  );
}
